module.exports = __webpack_public_path__ + "static/media/20201114_120358_193_IMG_9922.1125796a.jpg";